import React, { useState, useEffect } from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../components/datatable/AppDataGrid';
import { columns } from './component/journalhistory/columnJournalhistory';
import FetchApi from '../customhooks/Functionapi';
import { useDemoData } from '@mui/x-data-grid-generator';


import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import PageHeader from '../../components/pageheader/PageHeader';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';

function DocumentApproved() {

  const { data, loading } = useDemoData({
    dataSet: 'Commodity',
    rowLength: 10,
    maxColumns: 6,
  });

  const FetchApis = new FetchApi();
  const [datalist, setDatalist] = useState([])
  const [dataAll, setDataAll] = useState([])

  useEffect(() => {
    getJournalHistorylist()
  }, [])

  const getJournalHistorylist = async () => {

    await FetchApis.FethcGet(`/document/JournalSuccessfullylist`).then(res => {
      if (res.status == 200) {

        setDatalist(res.data);
        setDataAll(res.data);
      }


    })
 
  }

  function getRowId(row) {
    return row.JournalID;
  }

  const filterBySearch = (event) => {

    const query = event.target.value;

    const filteredData = dataAll.filter(item => {
      return Object.values(item)
        .join('')
        .toLowerCase()
        .includes(query.toLowerCase());
    });

    setDatalist(filteredData);
  };

  return (
    <div>
      <NavbarUser />
      <main className="container mx-auto px-4 py-8" style={{ padding: 10, backgroundColor: '#f7f7f7' }}>
        <PageHeader
          title="Approved Successfully All"
          subtitle="Manage document search journal successfully list"
          icon={DescriptionRoundedIcon}
          color="#43a047"
          count={datalist.length}
          onSearch={(e) => filterBySearch(e)}
        />
        <div>
          <div style={{ marginTop: 20 }}>
            <AppDataGrid
              rows={datalist}
              getRowId={getRowId}
              columns={columns}
              loading={loading}
              slots={{ toolbar: GridToolbar }}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              sx={{ border: 0 }}
              pageSizeOptions={[10, 25, 50, 100]}
            />
          </div>
        </div>
      </main>
    </div>
  )
}

export default DocumentApproved